export default class {
	/* @ngInject */
	constructor() {
		this.roomRef = undefined;
	}

	$onInit() {

	}

	$onChanges(changes) {
		if (changes?.room?.currentValue) {
			this.roomRef = changes?.room?.currentValue;
		}
	}
}
